import { useDndContext } from '@dnd-kit/core';
import { useSortable } from '@dnd-kit/sortable';
import DragIndicatorIcon from '@mui/icons-material/DragIndicator';
import theme from 'theme';

interface ColumnDragHandleProps {
  columnType: string;
}

const DRAG_HANDLE_WIDTH = 20;

const ColumnDragHandle = ({ columnType }: ColumnDragHandleProps) => {
  const { attributes, listeners, setNodeRef, setActivatorNodeRef, isDragging } = useSortable({ id: columnType });
  const { active, over } = useDndContext();

  const isDropTarget = Boolean(over?.id === columnType && active?.id !== columnType);

  return (
    <>
      {/* Full-cell overlay: registers the column as a sortable item and shows drop-target highlight.
          pointer-events: none ensures clicks/tooltips on the header cell still work. */}
      <div
        ref={setNodeRef}
        style={{
          position: 'absolute',
          inset: 0,
          zIndex: 1,
          pointerEvents: 'none',
          backgroundColor: isDropTarget ? `${theme.palette.primary.main}22` : 'transparent',
          borderLeft: isDropTarget ? `2px solid ${theme.palette.primary.main}` : '2px solid transparent',
          transition: 'background-color 0.15s ease, border-color 0.15s ease',
        }}
      />
      {/* Drag-handle icon on the left edge — the only interactive drag activation zone. */}
      <div
        ref={setActivatorNodeRef}
        {...listeners}
        {...attributes}
        style={{
          position: 'absolute',
          left: 0,
          top: 0,
          height: '100%',
          width: `${DRAG_HANDLE_WIDTH}px`,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          zIndex: 2,
          cursor: isDragging ? 'grabbing' : 'grab',
          opacity: isDragging ? 0 : 1,
          touchAction: 'none',
          userSelect: 'none',
        }}>
        <DragIndicatorIcon
          style={{
            fontSize: 14,
            color: isDropTarget ? theme.palette.primary.main : theme.palette.grey[500],
            pointerEvents: 'none',
          }}
        />
      </div>
    </>
  );
};

export default ColumnDragHandle;
